// extracted by mini-css-extract-plugin
export var component = "SubscriptionEvent-module--component--UqESe";
export var title = "SubscriptionEvent-module--title--wY4DA";
export var type = "SubscriptionEvent-module--type--jRF+0";